// extracted by mini-css-extract-plugin
export default {"container":"NoDocuments_container__uh3MA","fileIcon":"NoDocuments_fileIcon__wUYnp"};